<div class="flex justify-between items-start">
  <h1 mat-dialog-title class="mat-dialog-title">{{ heading }}</h1>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="modal-content">
  <form
    [formGroup]="eventForm"
    *ngIf="months && selectedMonth"
    class="event-form"
    #showForm
  >
    <app-event-details
      formControlName="details"
      [editing]="data.editing"
    ></app-event-details>

    <!-- Recurrence Information Display -->
    <div *ngIf="eventToEdit?.recurrence" class="recurrence-info">
      <mat-card class="recurrence-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>repeat</mat-icon>
            Recurring Event
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="recurrence-description">
            {{ getRecurrenceDescription() }}
          </p>
          <p class="recurrence-note">
            <mat-icon>info</mat-icon>
            The date below shows the specific event you clicked. When editing "all events in the series", the original start date ({{ formatOriginalStartDate() }}) will be preserved.
          </p>
        </mat-card-content>
      </mat-card>
    </div>

    <app-event-timing
      formControlName="timing"
      [months]="months"
      [selectedMonth]="selectedMonth"
      [eventPreview]="eventPreview"
      [editing]="data.editing"
      [eventToEdit]="data.event"
    ></app-event-timing>
    <div class="cta-footer">
      <button
        *ngIf="data.event"
        mat-button
        type="button"
        (click)="deleteEvent()"
        mat-raised-button
        color="warn"
      >
        Delete
      </button>
      <div class="modal-actions">
        <button
          mat-button
          (click)="closeModal()"
          type="button"
          mat-raised-button
          data-qa="cancel-event-modal"
        >
          Cancel
        </button>
        <app-progress-button
          color="accent"
          text="Save"
          (submit)="saveEvent($event)"
          [disabled]="eventForm.invalid"
          [submitting]="isSaving.value"
          data-qa="save-event-modal"
        >
        </app-progress-button>
      </div>
    </div>
  </form>
</div>
